import { Component, computed, input } from '@angular/core';

import { of } from 'rxjs';

import { UserLogoData, UsersListComponent } from '@camelot/ui';
import { CamBaseComponent } from '@camelot/utils';

import { CommunicationParticipantExtended } from '../../services/dto/communication';

@Component({
  selector: 'cam-communication-participants-list',
  templateUrl: './participants-list.component.html',
  styleUrls: ['./participants-list.component.scss'],
  imports: [UsersListComponent],
})
export class ParticipantsListComponent extends CamBaseComponent {
  conversationParticipants = input.required<CommunicationParticipantExtended[]>();

  readonly users$ = computed(() =>
    of(
      this.conversationParticipants().map((item): UserLogoData => {
        if (item.user) {
          return {
            firstName: item.user.firstName,
            lastName: item.user.lastName,
            picture: item.user.picture,
            trigram: item.user.trigram,
          };
        }
        if (item.contact) {
          return {
            firstName: item.contact.firstName,
            lastName: item.contact.lastName,
            trigram: '',
          };
        }
        return {
          firstName: item.email,
          lastName: '',
          trigram: '',
        };
      })
    )
  );
}
